import Rails from "@rails/ujs";

import N2StylesModal from "./N2StylesModal";

const prepresModalPresent = () => $(".js-prepress-submit").length;

const PrepressModalOpener = () => {
  if (prepresModalPresent()) {
    N2.bindHandler("click", ".js-prepress-submit", (evt) => {
      evt.preventDefault();
      new N2StylesModal(".js-submit-prepress-modal");
    });

    N2.bindHandler("change", "#product_proof_types_form input", () => {
      Rails.fire($("#product_proof_types_form")[0], "submit");
    });
  }
};

export default PrepressModalOpener;
